export function setAttributes(node, attrs) {
    for (const [key, value] of Object.entries(attrs)) {
        if (typeof value === "string") {
            node.setAttribute(key, value);
        }
    }
}
